import { createSlice } from "@reduxjs/toolkit";
import { DiseaseTypeDefaultDataset } from "../data_model/diseaseTypeModel/post_disease_type_model";

export const post_Disease_Type = createSlice({
  name: "post_disease_type",
  initialState: {
    value: {
      status: false,
      langMap: DiseaseTypeDefaultDataset,
      defaultLangMap: DiseaseTypeDefaultDataset,
    },
  },
  reducers: {
    resetLangMap: (state, action) => {
      state.value.langMap = DiseaseTypeDefaultDataset;
    },
    //add empty language dataset
    addNewLangData: (state, action) => {
      state.value.status = true;
      const incomingPayload = action.payload;
      const newArray = [...state.value.langMap.langMap, incomingPayload];
      state.value.langMap.langMap = newArray;
    },
    //update individual items in localization array
    replaceIndex: (state, action) => {
      const newPayload = action.payload;
      const existingPayload = state.value.langMap?.langMap;
      const newUpdateData = existingPayload.map((item) =>
        item.langCode === newPayload.langCode ? newPayload : item
      );
      state.value.langMap.langMap = newUpdateData;
    },
  },
});

export const { resetLangMap, addNewLangData, replaceIndex } =
  post_Disease_Type.actions;

export default post_Disease_Type.reducer;
